// @ts-nocheck
import { fabric } from 'fabric';
import _ from 'lodash';

import { removeDuplicateElement } from '../ui/helper';

let Grid;

(function () {
  Grid = function (canvas: any, config: any) {
    this.canvas = canvas;
    this.ctxChart = this.canvas.getContext('2d');
    this.update(config);
    this.config = config;
    this.gridMajorColor = '#0954BA';
    this.gridMinorColor = '#0C71FA33';
    this.configObject = {
      selectable: false,
      hasControls: false,
      hasBorders: false,
      hasRotatingPoint: false,
      selection: false,
      skipTargetFind: false,
      editable: false,
    };
    this.gridsLines = [];
    this.sizeGrid = 0;
  };

  Grid.prototype.draw = function () {
    // *: Clear canvas to draw a new grid
    this.canvas.clear();

    // *: Draw square minor
    this.drawSquareGrid(this.majorDivSize / 5, 1);

    // *: Draw border
    this.drawBorder();
    if (this.fineGrid) {
      this.drawSquareGrid(this.majorDivSize * 0.04, 1); // 0.04sec
    }
  };

  Grid.prototype.drawExportGrid = function () {
    this.sizeGrid = 0;

    // *: Draw square minor
    this.drawExportSquareGrid(this.canvas, this.majorDivSize / 5, 1, this.gridMinorColor);

    // *: Draw square major
    this.drawExportBorder();

    if (this.fineGrid) {
      this.drawExportSquareGrid(this.canvas, this.majorDivSize * 0.04, 1, this.gridMinorColor);
    }

    for (let i = this.sizeGrid; i < this.gridsLines.length; i += 1) {
      this.gridsLines[i].visible = false;
    }
  };

  Grid.prototype.render = function () {
    this.canvas.renderAll();
  };

  Grid.prototype.update = function (config: any) {
    this.config = config;
    const { width, height, majorDivSize, fineGrid } = config;
    this.width = width;
    this.height = height;
    this.majorDivSize = majorDivSize;
    this.fineGrid = fineGrid;
  };

  Grid.prototype.drawSquareGrid = function (side: any, thickness: any) {
    this.ctxChart.strokeStyle = this.gridMinorColor;
    this.ctxChart.lineWidth = thickness;

    // *: Draw vertical lines
    let i = 0;
    for (i = 0; i < this.width; i += side) {
      this.drawLine(i, this.height, i, 0);
    }
    if (i <= this.width) {
      this.drawLine(this.width, this.height, this.width, 0);
    }

    // *: Draw horizontal lines
    for (i = 0; i < this.height; i += side) {
      this.drawLine(this.width, i, 0, i);
    }
    if (i <= this.height) {
      this.drawLine(this.width, this.height, 0, this.height);
    }
  };

  Grid.prototype.drawLine = function (x1: any, y1: any, x2: any, y2: any) {
    this.ctxChart.beginPath();
    this.ctxChart.moveTo(x1, y1);
    this.ctxChart.lineTo(x2, y2);
    this.ctxChart.stroke();
    this.ctxChart.closePath();
  };

  Grid.prototype.drawBorder = function () {
    this.ctxChart.strokeStyle = this.gridMajorColor;
    this.ctxChart.lineWidth = 3;
    this.drawLine(0, 0, this.width, 0);
    this.drawLine(0, 0, 0, this.height);
    this.drawLine(this.width, 0, this.width, this.height);
    this.drawLine(0, this.height, this.width, this.height);
  };

  Grid.prototype.drawExportLine = function (
    x1: any,
    y1: any,
    x2: any,
    y2: any,
    strokeWidth: any,
    stroke: any,
  ) {
    if (this.sizeGrid < this.gridsLines.length) {
      this.gridsLines[this.sizeGrid].set({
        x1,
        y1,
        x2,
        y2,
        strokeWidth,
        stroke,
      });
      this.gridsLines[this.sizeGrid].setCoords();
      this.gridsLines[this.sizeGrid].visible = true;
    } else {
      const line = new fabric.Line([x1, y1, x2, y2], {
        ...this.configObject,
        strokeWidth,
        stroke,
      });
      this.canvas.add(line);
      this.gridsLines.push(line);
    }
    this.sizeGrid += 1;
  };

  Grid.prototype.drawExportSquareGrid = function (
    context: any,
    side: any,
    thickness: any,
    color: any,
  ) {
    context.strokeStyle = color;

    // *: Draw vertical lines
    let i = 0;
    for (i = 0; i < this.width; i += side) {
      this.drawExportLine(i - thickness / 2, this.height, i - thickness / 2, 0, thickness, color);
    }
    if (i <= this.width + thickness) {
      this.drawExportLine(
        this.width - thickness / 2,
        this.height,
        this.width - thickness / 2,
        0,
        thickness,
        color,
      );
    }

    // *: Draw horizontal lines
    for (i = 0; i < this.height; i += side) {
      this.drawExportLine(this.width, i - thickness / 2, 0, i - thickness / 2, thickness, color);
    }
    if (i <= this.height + thickness) {
      this.drawExportLine(
        this.width,
        this.height - thickness / 2,
        0,
        this.height - thickness / 2,
        thickness,
        color,
      );
    }
  };

  Grid.prototype.drawExportBorder = function () {
    this.drawExportLine(0, 0, this.width, 0, 1, this.gridMajorColor);
    this.drawExportLine(this.width - 1, 0, this.width - 1, this.height, 1, this.gridMajorColor); // *: Minus 0.5px
    this.drawExportLine(
      0,
      this.height - 1,
      this.width - 0.5,
      this.height - 1,
      1,
      this.gridMajorColor,
    ); // *: Minus 0.5px
    this.drawExportLine(0, 0, 0, this.height, 1, this.gridMajorColor);
  };

  Grid.prototype.changeColorForAllStrip = function (isAllStrip: any) {
    this.canvas.backgroundColor = isAllStrip ? '#F5F7FA' : '#fafafa';
  };

  Grid.prototype.showHideGrid = function (isVisibility: any) {
    _.forEach(this.gridsLines, (x) => {
      x.visible = isVisibility;
    });
  };

  Grid.prototype.export = function () {
    const svg = this.canvas.toSVG(
      {
        viewBox: {
          x: 0,
          y: 0,
          width: 945,
          height: 250,
        },
      },
      (e: any) => (e.includes('hidden') ? '' : e),
    );

    return removeDuplicateElement(svg);
  };
})();

export { Grid };
export default { Grid };
